import { z } from "zod";

export const contactFormCommon = z.object({
  name: z.string().optional().nullable(),
  user: z.object({
    account_id: z.string().optional().nullable(),
    avatar_url: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    phone_number: z.number(),
    company_details_form: z.object({
      address: z.string().optional().nullable(),
      city: z.string().optional().nullable(),
      gstin: z.string().optional().nullable(),
      legal_name: z.string().optional().nullable(),
      pan_number: z.string().optional().nullable(),
      pincode: z.string().optional().nullable(),
      state: z.string().optional().nullable(),
      transport_name: z.string().optional().nullable(),
    }).optional().nullable(),
  }).optional().nullable(),
  tags: z.array(z.string()).optional().nullable(),
  role_permission_name: z.string().optional().nullable(),
  notes: z.string().optional().nullable(),
  status: z.enum(["approved", "banned", "pending"]).default("pending"),
  designation: z.string().optional().nullable(),
});

export const contactFormCreate = contactFormCommon.extend({
  company_ledger_name: z.string().optional().nullable(),
});

export const contactFormEdit = contactFormCreate.extend({
  id: z.string()
});

export const contact = contactFormEdit.extend({
  inserted_at: z.string()
});

export const teamMemberFormCreate = contactFormCommon.extend({
  role_permission_name: z.string().optional().nullable().refine((val) => {
    if (!val) return true; // Allow null or undefined values
    return val !== "super_admin" && val !== "user" && val !== "ai_bot";
  }, {
    message: "Role permission name cannot be super-admin, user or ai-bot"
  }),
});

export const teamMemberFormEdit = teamMemberFormCreate.extend({
  id: z.string()
});

export const teamMember = teamMemberFormEdit.extend({
  inserted_at: z.string()
});

export type ITeamMemberFormCreate = z.infer<typeof teamMemberFormCreate>;
export type ITeamMemberFormEdit = z.infer<typeof teamMemberFormEdit>;
export type ITeamMember = z.infer<typeof teamMember>;

export type IContact = z.infer<typeof contact>;
export type IContactFormCreate = z.infer<typeof contactFormCreate>;
export type IContactFormEdit = z.infer<typeof contactFormEdit>;

export type IContactFormValuesType<A extends "create" | "edit", E extends "account" | "team-member"> = 
  A extends "create" 
    ? (E extends "account" ? IContactFormCreate : ITeamMemberFormCreate)
    : (E extends "account" ? IContactFormEdit : ITeamMemberFormEdit);

export const accountCreateEditSchema = (entityType: "account" | "team-member", actionType: "create" | "edit") => {
  return entityType === "account" ? actionType === "create" ? contactFormCreate : contactFormEdit : actionType === "create" ? teamMemberFormCreate : teamMemberFormEdit;
}
